var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAdd16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_add_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_add_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#005082",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18621654,4.55118571 L7.18621654,7.18621654 L4.55118571,7.18621654 C4.10034967,7.18621654 3.73333333,7.5475364 3.73333333,8 C3.73333333,8.44920847 4.10034967,8.81378346 4.55118571,8.81378346 L7.18621654,8.81378346 L7.18621654,11.4488143 C7.18621654,11.8996503 7.5475364,12.2666667 8,12.2666667 C8.44920847,12.2666667 8.81378346,11.8996503 8.81378346,11.4488143 L8.81378346,8.81378346 L11.4488143,8.81378346 C11.9004641,8.81378346 12.2666667,8.4524636 12.2666667,8 C12.2666667,7.55079153 11.8996503,7.18621654 11.4488143,7.18621654 L8.81378346,7.18621654 L8.81378346,4.55118571 C8.81378346,4.09953589 8.4524636,3.73333333 8,3.73333333 C7.55079153,3.73333333 7.18621654,4.10034967 7.18621654,4.55118571 Z",
    id: "Clip-2",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd16);
export default __webpack_public_path__ + "static/media/icon_add_16.a8fd1e01c9af5d758022d6ff4c58391d.svg";
export { ForwardRef as ReactComponent };